// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__PugWK","popup__modal":"Popup_popup__modal__RncRc","popup__modal__content":"Popup_popup__modal__content__6NNgc","btnClose":"Popup_btnClose__rnJ2R"};